import styled from '@emotion/styled';
import { Grid, Skeleton as MuiSkeleton } from '@mui/material';

const CardWrapper = styled(Grid)`
  min-height: 160px;
`;

const ContentWrapper = styled(Grid)`
  padding: 24px;
  row-gap: 16px;
`;

const Skeleton = styled(MuiSkeleton)`
  border-radius: 4px;
  margin: 0;
  padding: 0;
`;

const AirlineNameSkeleton = styled(MuiSkeleton)`
  border-radius: 4px;
  margin: 0;
  padding: 0;
  margin-top: 10px;
`;

const RoundedRectSkeleton = styled(MuiSkeleton)`
  border-radius: 100px;
`;

const PriceSkeletonWrapper = styled(Grid)`
  border-left: 1px solid #e0e0e0;
  padding: 24px;
`;

export default {
  Skeleton,
  PriceSkeletonWrapper,
  CardWrapper,
  ContentWrapper,
  RoundedRectSkeleton,
  AirlineNameSkeleton,
};
